import script from "./dlap.vue?vue&type=script&setup=true&lang=js"
export * from "./dlap.vue?vue&type=script&setup=true&lang=js"

import "./dlap.vue?vue&type=style&index=0&id=22a4ee9b&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22a4ee9b"]])

export default __exports__